import React from 'react'
import Icon from 'antd/es/icon'
import TableContextMenuComponent from '../common/TableContextMenuComponent'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import DownloadIcon from "@material-ui/icons/GetAppSharp"
import ButtonGroup from '@material-ui/core/ButtonGroup'
import Button from '@material-ui/core/Button'

const optionsForStatusAssigned = [
    'Detalle'
]

// General Colums
export const ColumnsForStatusAssigned = (
    [
        {
            name: 'Folio Cotización',
            selector: 'folioQuote',
            width: '90px',
            sortable: true,
            cell: row => row.folioQuote
        },
        {
            name: 'Folio Orden',
            selector: 'orderNumber',
            width: '90px',
            sortable: true,
            cell: row => row.orderNumber
        },
        {
            name: 'Fecha',
            selector: 'orderDate',
            sortable: true,
            cell: row => row.orderDate
        },
        {
            name: 'Vin',
            selector: 'vin',
            width: '165px',
            sortable: true,
            cell: row => row.vin
        },
        {
            name: 'Número OC',
            selector: 'poNumber',
            width: '150px',
            sortable: true,
            cell: row => row.poNumber
        },
        {
            name: 'Marca',
            selector: 'brand',
            sortable: true,
            cel: row => row.brand
        },
        {
            name: 'Modelo',
            selector: 'model',
            width: '130px',
            sortable: true,
            cell: row => row.model
        },
        {
            name: 'Versión',
            selector: 'version',
            width: '160px',
            sortable: true,
            cell: row => row.version
        },
        {
            name: 'Año',
            selector: 'year',
            sortable: true,
            width: '70px',
            cell: row => row.year
        },
        {
            name: 'Días Transcurridos',
            selector: 'daysPassed',
            sortable: true,
            cell: row => row.daysPassed
        },
        {
            name: 'Fecha de pago',
            selector: 'paymentDate',
            sortable: true,
            cell: row => row.paymentDate
        },
        {
            name: "Notificaciones",
            selector: 'notifications',
            sortable: true,
            cell: row => row.notifications === true ? "Si" : "No"
        },
        {
            cell: row => <TableContextMenuComponent row={row} menuOptions={optionsForStatusAssigned} />,
            allowOverflow: true,
            button: true,
            width: '56px', // custom width for icon button
        }
    ]
)

export const ColumnsForStatusApproved = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '56px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Folio Cotización',
            selector: 'folioQuote',
            width: '90px',
            sortable: true,
            cell: row => row.folioQuote
        },
        {
            name: 'Folio Orden',
            selector: 'orderNumber',
            width: '90px',
            sortable: true,
            cell: row => row.orderNumber
        },
        {
            name: 'Fecha',
            selector: 'date',
            sortable: true,
            cell: row => row.date
        },
        {
            name: 'Vin',
            selector: 'vin',
            sortable: true,
            cell: row => row.vin
        },
        {
            name: 'Número OC',
            selector: 'poNumber',
            sortable: true,
            cell: row => row.poNumber
        },
        {
            name: 'Marca/Modelo/Year',
            selector: 'auto',
            sortable: true,
            cell: row => row.auto
        },
        {
            name: 'Días Transcurridos',
            selector: 'daysPassed',
            sortable: true,
            cell: row => row.daysPassed
        },
        {
            name: 'Programación de pago',
            selector: 'paymentDate',
            sortable: true,
            cell: row => row.paymentDate
        }
    ]
)

export const ColumnsForStatusPendingPayment = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '56px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Folio Cotización',
            selector: 'folioQuote',
            width: '90px',
            sortable: true,
            cell: row => row.folioQuote
        },
        {
            name: 'Folio Orden',
            selector: 'orderNumber',
            width: '90px',
            sortable: true,
            cell: row => row.orderNumber
        },
        {
            name: 'Fecha',
            selector: 'date',
            sortable: true,
            cell: row => row.date
        },
        {
            name: 'Vin',
            selector: 'vin',
            sortable: true,
            cell: row => row.vin
        },
        {
            name: 'Número OC',
            selector: 'poNumber',
            sortable: true,
            cell: row => row.poNumber
        },
        {
            name: 'Marca/Modelo/Year',
            selector: 'auto',
            sortable: true,
            cell: row => row.auto
        },
        {
            name: 'Días Transcurridos',
            selector: 'daysPassed',
            sortable: true,
            cell: row => row.daysPassed
        },
        {
            name: 'Programación de pago',
            selector: 'paymentDate',
            sortable: true,
            cell: row => row.paymentDate
        }
    ]
)

export const ColumnsForStatusPayed = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '56px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Folio Cotización',
            selector: 'folioQuote',
            width: '90px',
            sortable: true,
            cell: row => row.folioQuote
        },
        {
            name: 'Folio Orden',
            selector: 'orderNumber',
            width: '90px',
            sortable: true,
            cell: row => row.orderNumber
        },
        {
            name: 'Fecha',
            selector: 'date',
            sortable: true,
            cell: row => row.date
        },
        {
            name: 'Vin',
            selector: 'vin',
            sortable: true,
            cell: row => row.vin
        },
        {
            name: 'Número OC',
            selector: 'poNumber',
            sortable: true,
            cell: row => row.poNumber
        },
        {
            name: 'Marca/Modelo/Year',
            selector: 'auto',
            sortable: true,
            cell: row => row.auto
        },
        {
            name: 'Días Transcurridos',
            selector: 'daysPassed',
            sortable: true,
            cell: row => row.daysPassed
        },
        {
            name: 'Programación de pago',
            selector: 'paymentDate',
            sortable: true,
            cell: row => row.paymentDate
        }
    ]
)

//Secondary colums
export const ColumnsForUploadEvidence = (disabled, { handleDownload, handleDelete }) => (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '56px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Nombre del documento',
            selector: 'fileName',
            sortable: true,
            width: '400px',
            cell: row => row.fileName
        },
        {
            name: 'Tipo de documento',
            selector: 'evidenceType',
            sortable: true,
            width: '250px',
            cell: row => (ShowEvidenceType(row.evidenceType))
        },
        {
            name: 'Opciones',
            width: '80px',
            cell: row => (EvidenceOptions(row, disabled, { handleDownload, handleDelete }))
        }
    ]
)

export const ColumnsForOtherInvoice = ({ handleDownload, handleDelete }) => (
    [
        {
            name: 'Documento',
            selector: 'documentName',
            sortable: true,
            width: '290px',
            cell: row => row.documentName
        },
        {
            name: 'Tipo de factura',
            selector: 'invoiceType',
            sortable: true,
            width: '130px',
            cell: row => (ShowInvoiceType(row.invoiceType))
        },
        {
            name: 'UUID',
            selector: 'UUID',
            sortable: true,
            width: '290px',
            cell: row => row.uuid
        },
        {
            name: 'Estatus',
            selector: 'status',
            width: '160px',
            sortable: true,
            cell: row => row.status === 'OC Aprobada' ? 'Factura recibida' : row.status
        },
        {
            name: 'Acciones',
            width: '110px',
            cell: row => (DocumentOptions(row, { handleDownload, handleDelete }))
        }
    ]
)

//Additional Features to colums
const ShowInvoiceType = (invoiceType) => {
    switch (invoiceType) {
        case "VE":
            return ("Vehículo")
        case "AC":
            return ("Accesorio")
        case "NC":
            return ("Nota de crédito")
        case "TR":
            return ("Traslado")
        case "RIGHT":
            return ("Derecho")
        case "COLL":
            return ("Gestoría")
        default:
            break;
    }
}

const DocumentOptions = (row, { handleDownload, handleDelete }) => {
    return (
        <ButtonGroup size="small" aria-label="Small outlined button group">
            <Button style={{ color: '#82C341', border: '0px' }} title="Descargar" onClick={() => handleDownload(row.buketName, row.invoiceType === 'RIGHT' ? 'DERECHO' : 'INVOICE')}>
                <DownloadIcon />
            </Button>
            {
                !row.acceptanceByNvp && (
                    <Button style={{ color: '#BF2E2E', border: '0px' }} title="Eliminar" onClick={() => handleDelete(row.invoiceId, row.invoiceType === 'RIGHT' ? 'DERECHO' : 'INVOICE')}>
                        <DeleteForeverIcon />
                    </Button>
                )
            }
        </ButtonGroup>
    )
}

const ShowEvidenceType = (evidenceType) => {
    switch (evidenceType) {
        case "rightPayment":
            return ("Pago de derecho")
        case "CirculationTarget":
            return ("Tarjeta de Circulación")
        case "Plates":
            return ("Placas")
        case "verificationStub":
            return ("Talón de verificación")
        default:
            break;
    }
}

const EvidenceOptions = (row, disabled, { handleDownload, handleDelete }) => {
    return (
        <ButtonGroup size="small" aria-label="Small outlined button group">
            <Button aria-label="delete" style={{ color: '#82C341', border: '0px' }} title="Descargar" onClick={() => handleDownload(row.id)}>
                <DownloadIcon />
            </Button>
            {
                !disabled && (
                     <Button aria-label="delete" style={{ color: '#C22727', border: '0px' }} title="Eliminar" onClick={() => handleDelete(row.id, row.nameInContainer)}>
                         <DeleteForeverIcon />
                     </Button>
                )
            }
        </ButtonGroup>
    )
}